module.exports = __webpack_public_path__ + "static/commandes-55a0a397ff2089364edf3a89012f42e0.jpg";